module.exports = __webpack_public_path__ + "assets/img/provider-poster-03.8cc2e692.png";